<template>
  <div class="chart-left-panel">
    <div v-if="colorvalue">
      <div v-for="newIndex in 6" :key="newIndex - 1" 
      class="left-panel__item red-color">
        <div :class="[
             'rcv__canditate-profile',
             {'disabled-item': isDisabled(newIndex - 1)}
           ]">
          <div :class="['rcv__candidate-avatar', getStaticColorClass(newIndex - 1)]">
           
            <img
              v-if="candidates[getOriginalIndex(newIndex - 1)] && candidates[getOriginalIndex(newIndex - 1)].imageUrl"
              :src="candidates[getOriginalIndex(newIndex - 1)].imageUrl"
              :alt="candidates[getOriginalIndex(newIndex - 1)].altText" width="90" height="90" />
          </div>
        </div>

        <div v-if="getOriginalIndex(newIndex - 1) == 0 && step == 6" class="burst-bg">
        </div>

        <div :class="[
             'content-text',
             {'disabled-item': isDisabled(newIndex - 1)}
           ]">
          <h5>{{ candidates[getOriginalIndex(newIndex - 1)].candidateName }}</h5>
          <div class="vote-value">
            <p>{{ getAccumulatedVotes(getOriginalIndex(newIndex - 1)) }} {{voterText}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconComponent",

  data() {
    return {
      burstclass: null,
      orderMapping: [0, 1, 2, 3, 4, 5],
      // Map colors to their corresponding classes
      colorClassMap: {
        "#367d54": "rcv__candidate-color-6",  // green
        "#fdf751": "rcv__candidate-color-1",  // yellow
        "#221649": "rcv__candidate-color-2",  // dark blue
        "#4ba3b7": "rcv__candidate-color-3",  // light blue
        "#ed7aca": "rcv__candidate-color-4",  // pink
        "#eb5534": "rcv__candidate-color-5"   // orange
      },
      accumulatedVotes: [0, 0, 0, 0, 0, 0],
      previousVotes: [0, 0, 0, 0, 0, 0]
    };
  },

  props: ["step", "colorvalue", "candidates", "votes", "isNext","voterText"],

  watch: {
    votes: {
      handler(newVotes) {
        // Update accumulated votes when votes prop changes
        if (this.isNext) {
          if (newVotes && newVotes.length) {
            this.accumulatedVotes = this.accumulatedVotes.map((prev, index) =>
              prev + (newVotes[index] || 0)
            );
          }
        }
        else{
          if (this.step === 1) {
          this.accumulatedVotes = [0, 0, 0, 0, 0, 0];
        } else if (this.step === 2) {
          this.accumulatedVotes = [25, 15, 10, 5, 30, 15];
        } else if (this.step === 3) {
          this.accumulatedVotes = [27, 16, 10, 5, 32, 15];
        } else if (this.step === 4) {
          this.accumulatedVotes = [32, 17, 10, 5, 32, 15];
        } else if (this.step === 5) {
          this.accumulatedVotes = [46, 17, 10, 5, 37, 16];
        }
        }
      }
    },
    step: {
      handler(step, oldStep) {
       
      }
    }
  },
  methods: {
    isDisabled(index) {
      const originalIndex = this.getOriginalIndex(index);
      switch (this.step) {
        case 3:
          return originalIndex === 3; // disable 4th item
        case 4:
          return originalIndex === 2 || originalIndex === 3; // disable 3rd and 4th items
        case 5:
          return originalIndex === 2 || originalIndex === 3 || originalIndex === 5; // disable 3rd, 4th, 6th items
        case 6:
          return originalIndex === 1 || originalIndex === 2 || originalIndex === 3 || originalIndex === 5; // disable 2nd, 3rd, 4th, 6th items
        default:
          return false;
      }
    },
    // Convert the display index to the original data index
    getOriginalIndex(displayIndex) {
      return this.orderMapping[displayIndex];
    },

    // Get the static color class based on display position
    getStaticColorClass(displayIndex) {
      const originalIndex = this.getOriginalIndex(displayIndex);
      const candidate = this.candidates[originalIndex];
      if (candidate && candidate.color) {
        return this.colorClassMap[candidate.color] || "rcv__candidate-color-6"; // default to color-6 if no match
      }
      return "rcv__candidate-color-6"; // default color class
    },

    // Get accumulated votes for a candidate
    getAccumulatedVotes(index) {
      return this.accumulatedVotes[index];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PracticeRcvv2/CandidateIconComponentV2.vue